import {
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL,
    RESET_MENSTRUAL_CYCLING_TRACKING_REPORTS
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    menstrualCycleTrackingReportsCycleSummaries: null,
    dailyLogs: null,
    avgCycleLength: null,
    avgPeriodLength: null,
    nextPage: false,
    prevPage: false,
    menstrualCycleTrackingReportsFetching: false,
    menstrualCycleTrackingReportsNoContentForSixCycles: false,
    menstrualCycleTrackingReportsSuccess: null
};

const menstrualCycleTrackingReportsFetching = (state) => {
    return {
        ...state,
        menstrualCycleTrackingReportsFetching: true
    };
};

const menstrualCyclingTrackingReportsFetchFinishedFail = (isSuccess) => (state, action) => {
    return {
        ...state,
        menstrualCycleTrackingReportsFetching: false,
        menstrualCycleTrackingReportsSuccess: isSuccess
    };
};

const menstrualCyclingTrackingReportsFetchFinished = (isSuccess) => (state, action) => {
    const { response, payloadData } = action;
    let newState = { ...state };

    if (payloadData && payloadData.numberOfCycles === 6) {
        newState = {
            ...state,
            menstrualCycleTrackingReportsNoContentForSixCycles: response.status === 204
        };
    }

    return {
        ...newState,
        menstrualCycleTrackingReportsCycleSummaries: response.data ? response.data.cycleSummaries : [],
        dailyLogs: response.data ? response.data.dailyLogs : null,
        avgCycleLength: response.data ? response.data.avgCycleLength : null,
        avgPeriodLength: response.data ? response.data.avgPeriodLength : null,
        nextPage: response.data ? response.data.nextPage : false,
        prevPage: response.data ? response.data.prevPage : false,
        menstrualCycleTrackingReportsFetching: false,
        menstrualCycleTrackingReportsSuccess: isSuccess
    };
};

export const getMenstrualCycleTrackingReportsNoContentForSixCycles = (state) => {
    return state.menstrualCycleTrackingReports.menstrualCycleTrackingReportsNoContentForSixCycles;
};

export const getMenstrualCycleTrackingReportsCycleSummaries = (state) => {
    return state.menstrualCycleTrackingReports.menstrualCycleTrackingReportsCycleSummaries;
};

export const getMenstrualCycleTrackingReportsCycleIsFetching = (state) => {
    return state.menstrualCycleTrackingReports.menstrualCycleTrackingReportsFetching;
};

const resetMenstrualCycleTrackingReports = () => {
    return { ...INITIAL_STATE };
};

const handlers = {
    [FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING]: menstrualCycleTrackingReportsFetching,
    [FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS]: menstrualCyclingTrackingReportsFetchFinished(true),
    [FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL]: menstrualCyclingTrackingReportsFetchFinishedFail(false),
    [RESET_MENSTRUAL_CYCLING_TRACKING_REPORTS]: resetMenstrualCycleTrackingReports
};

export default function menstrualCycleTrackingReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
